import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import ReportRunner from "../components/ReportRunner";
import { reportList } from "../reports";

// Reports are grouped into sections by their `section` field (default "statement").
const SECTIONS = [
   { key: "statement", title: "Statement reports" },
   { key: "audit", title: "Audit reports" },
];

const sectionOf = (r) => (r.section === "audit" ? "audit" : "statement");

function ReportColumn({ title, reports, onOpen }) {
   return (
      <div>
         <div
            style={{
               fontSize: 13,
               fontWeight: 600,
               color: "#16191f",
               paddingBottom: 8,
               borderBottom: "2px solid #16191f",
            }}
         >
            {title}
         </div>
         <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
            {reports.length === 0 && (
               <li style={{ padding: "10px 0", color: "#6c757d", fontSize: 14 }}>None yet</li>
            )}
            {reports.map((r) => (
               <li key={r.id} style={{ padding: "10px 0", borderBottom: "1px solid #dee2e6" }}>
                  <a
                     href="#"
                     style={{ color: "#0073bb", fontWeight: 400, fontSize: 14, textDecoration: "none" }}
                     onClick={(e) => {
                        e.preventDefault();
                        onOpen(r.id);
                     }}
                  >
                     {r.title}
                  </a>
               </li>
            ))}
         </ul>
      </div>
   );
}

export default function Reports() {
   const [openId, setOpenId] = useState(null);
   return (
      <React.Fragment>
         <Header />
         <div className="main main-app reports-page p-3 p-lg-4 p-xxl-5">
            {!openId && (
               <>
                  <h2 className="main-title fs-4 mb-1">Reports</h2>
                  <Row className="g-4 g-lg-5" style={{ maxWidth: 900 }}>
                     {SECTIONS.map((s) => (
                        <Col md={6} key={s.key}>
                           <ReportColumn
                              title={s.title}
                              reports={reportList.filter((r) => sectionOf(r) === s.key)}
                              onOpen={setOpenId}
                           />
                        </Col>
                     ))}
                  </Row>
               </>
            )}
            {openId && (
               <>
                  <div className="mb-3" style={{ fontSize: 13 }}>
                     <a
                        href="#"
                        style={{ color: "#0073bb", textDecoration: "none" }}
                        onClick={(e) => { e.preventDefault(); setOpenId(null); }}
                     >
                        Reports
                     </a>
                     <span style={{ color: "#6c757d" }}> ▸ {reportList.find((r) => r.id === openId)?.title}</span>
                  </div>
                  <ReportRunner reportId={openId} />
               </>
            )}
            <Footer />
         </div>
      </React.Fragment>
   );
}
